// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"ccd4aa74","70":"cec657ba","443":"99973ad3","478":"1153a5a3","496":"78a452f7","602":"c18066c7","663":"71d997f1","699":"83930739","719":"bd6a6ea8","744":"79c928d5","757":"85194a61","848":"e34a41eb"}[chunkId] + ".chunk.js";
};